// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type RadioCheckedIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from radio-checked.svg
 */
export default function RadioCheckedIcon(props: RadioCheckedIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="RadioCheckedIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"
          clip-rule="evenodd"
        />
        <path fill="currentColor" d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0" />
      </g>
    </svg>
  );
}
